<!--
    描述：项目管理--项目结构
    时间：2020-05-18
    Created by ws
-->
<template>
	<w-split v-model="splitV">
		<left-structure slot="left"
						@rowClick="rowClick"></left-structure>
		<right-structure slot="right"
						 :resData="resData"
						 :curRangeType="curRangeType"
						 :curRowId="curRowId"
						 v-loading="loading"></right-structure>
	</w-split>
</template>

<script>
import leftStructure from './components/left_structure'
import rightStructure from './components/right_structure'
import { structureFieldsAndValue } from '@/api/modules/analysis'
import { getDictByParentValue } from '@/api/modules/dict.js'

export default {
	components: {
		leftStructure,
		rightStructure
	},
	data() {
		return {
			splitV: 0.3,
			curLevelType: '', // 当前结构层级 (0, 1, 2)
			curRowId: '', // 当前row id
			curRangeType: '',
			resData: [],
			loading: false
		}
	},
	methods: {
		// 左侧树点击事件
		rowClick(row) {
			this.loading = true
			let _rangeType = ''

			switch (row.levelType) {
				case 0:
					_rangeType = row.projectType
					break
				case 1:
					_rangeType = row.levelTypeCode
					break
			}
			this.curLevelType = row.levelType
			this.curRowId = row.id
			this.curRangeType = _rangeType
			this.resData = []

			if (row.levelType !== 2) {
				structureFieldsAndValue({
					rangeType: _rangeType,
					aid: this.curProjectId,
					contractTreeId: row.id
				})
					.then(res => {
						this.loading = false
						let length_list = []

						res.data.forEach(x => {
							// 正常结构
							x.usualFieldList.map(y => {
								// 系统码表
								if (y && y.formType === '1005007' || y && y.formType === '1005008'  || y && y.formType === '1005009') {
									this.getDict(
                      y.additional.dictionaryType
									).then(res => {
										y.options = res.data
									})
								}
							})

							// 树结构
							x.specialBlockList.map(y => {
								// 系统码表
								if (y && y.formType === '1005007' || y && y.formType === '1005008' || y && y.formType === '1005009') {
									this.getDict(
                      y.additional.dictionaryType
									).then(res => {
										y.options = res.data
									})
								}

								y.children.map(z => {
									// 系统码表
									if (z && z.formType === '1005007' || y && y.formType === '1005008' || y && y.formType === '1005009') {
										this.getDict(
											z.additional.dictionaryType
										).then(res => {
											z.options = res.data
										})
									}
								})
							})

							// 平级结构
							let _colspan = x.commonBlockList.filter(z => z.rowIndex === 1).length
							x.commonBlockList.map(y => {
								// 一行几个col
								y.parentCol = _colspan
								// 设置colSpan
								if (!length_list[y.rowIndex]) {
									length_list[y.rowIndex] = []
								}
								length_list[y.rowIndex].push(y)

								// 系统码表
								if (y && y.formType === '1005007' || y && y.formType === '1005008' || y && y.formType === '1005009') {
									this.getDict(
                      y.additional.dictionaryType
									).then(res => {
										y.options = res.data
									})
								}
							})

							// 数组去空
							length_list = length_list.filter(
								y => y.length && y.length > 0
							)
							x.colSpan =
								length_list.length === 0
									? 1
									: length_list[0].length
						})

						setTimeout(() => {
							this.resData = res.data
						}, 500)
					})
					.catch(err => {
						this.loading = false
					})
			} else {
				this.$message.warning('单位工程下 暂无数据！')
				this.loading = false
			}
		},

		// 获取码表数组
		async getDict(value) {
			let res = await getDictByParentValue({ value: value })

			return Promise.resolve(res)
		}
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId || ''
		}
	}
}
</script>

<style scoped lang="less">
</style>
